// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#home-page[data-v-7b4801d6]{height:100vh;position:relative}#home-page .main-content[data-v-7b4801d6]{margin-left:220px!important;padding:30px 20px;height:calc(100vh - 72px);box-sizing:border-box;overflow-y:auto;background-color:#f9f9f9}", ""]);
// Exports
module.exports = exports;
